import type { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { type EnrichedDeliveryPreference } from '../model/model.js'

type Props = {
  preference: EnrichedDeliveryPreference
}

type Args = {
  preference: EnrichedDeliveryPreference
  fallback?: string
}

export const useGetDeliveryPreferenceDescription = () => {
  const { t } = useTranslation()

  return ({ preference, fallback }: Args): string => {
    const { activeSetting, agreedPlaceSettings, servicePointSettings } = preference

    if (activeSetting.preferenceType === 'ServicePointDelivery' && servicePointSettings) {
      return servicePointSettings.servicepointName
    }

    if (activeSetting.preferenceType === 'DoorDelivery' && activeSetting.fallback?.preferenceType === 'NoPreference') {
      return t('portal.profile.preferences.options.neighbours.ringDoorbellDescription')
    }

    if (
      activeSetting.preferenceType === 'DoorDelivery' &&
      activeSetting.fallback?.preferenceType === 'AgreedPlaceDelivery'
    ) {
      return t('portal.profile.preferences.options.AgreedPlaceDelivery.ringDoorbellDescription', {
        agreedPlace: agreedPlaceSettings?.description,
      })
    }

    if (activeSetting.preferenceType === 'AgreedPlaceDelivery') {
      return t('portal.profile.preferences.options.AgreedPlaceDelivery.noRingDoorbellDescription', {
        agreedPlace: agreedPlaceSettings?.description,
      })
    }

    return fallback ?? t('portal.profile.preferences.options.neighbours.ringDoorbellDescription')
  }
}

export const DeliveryPreferenceDescription: FC<Props> = ({ preference }) => {
  const getDescription = useGetDeliveryPreferenceDescription()

  return <>{getDescription({ preference })}</>
}
